var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"google-country-map"},[_c('div',{ref:"chart",staticClass:"google-country-map__canvas"}),(_vm.isEmpty)?_c('div',{staticClass:"google-country-map__empty"},[_vm._v(" 当前月份暂无国家地区数据 ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }